import React from "react";

export default function Fifteen({ fill, children }) {
  return (
    <svg
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <path d="M242.1,298.92H57.9A20.73,20.73,0,0,1,37.19,278.2V22.28A20.73,20.73,0,0,1,57.9,1.57H242.1a20.73,20.73,0,0,1,20.71,20.71V278.2A20.73,20.73,0,0,1,242.1,298.92ZM57.9,6.13A16.17,16.17,0,0,0,41.75,22.28V278.2A16.18,16.18,0,0,0,57.9,294.36H242.1a16.18,16.18,0,0,0,16.15-16.16V22.28A16.17,16.17,0,0,0,242.1,6.13Z" />
      <rect x="70.75" y="72.88" width="159.16" height="5.13" />
      {children}
    </svg>
  );
}
